import moment from "moment";

export const getTimezoneLabel = (value) => {

    const tz = moment.tz(value);
    const hours = tz.format('Z');
    return `(GMT${hours}) ${value}`;

}

export const humanFormat = (date) => {
     try {
          return moment(date).fromNow()
     } catch (err) {
          return `Invalid date (${date})`;
     }
}

export const formatDateTime = (dateTime) => {

     try {
          if (dateTime === null || dateTime === '') {
               return '';
          } else {
               return moment(dateTime).format('DD/MM/YY HH:mm:ss');
          }
     }
     catch(err) {
          return '';
     }

}

export const formatDate = (date) => {

     try {
          if (date === null || date === '') {
               return '';
          } else {
               return moment(date).format('DD/MM/YY');
          }
     }
     catch(err) {
          return '';
     }

}

export function formatDaysFromNow(dateInput) {

    const date = moment(dateInput);
    const today = moment();
    const diffDays = date.diff(today, 'days');

    if (diffDays === 0) {
        return 'Today';
    } else if (diffDays === -1) {
        return 'Yesterday';
    } else if (diffDays === 1) {
        return 'Tomorrow';
    } else if (diffDays < -1) {
        return `${Math.abs(diffDays)} days ago`;
    } else {
        return `in ${diffDays} days`;
    }
}
